import { Component, OnInit } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ModalService } from '../shared/modal/modal.service';
import { LoadingService } from '../shared/loading/loading.service';

import Utils from '../shared/utility';

// import { animateNumber } from '../../assets/tools/util';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public error: any;
  public leads;
  public reports: any;
  public activeAdvisors: any;
  public inactiveAdvisors: any;

  public allClients: any;
  public allReports: any;

  public clientsAdded: number = 0;
  public totalClients: number = 0;

  public reportsCreated: number = 0;

  public recentClients: any = [];
  public recentReports: any = [];

  public clientIncomeAddedMessage: string = "This metric is an approximate combination of two elements effective March 5, 2018: Social Security benefit improvements (estimated by subtracting Earliest total from Alternate total), and income added back due to reduction or elimination of Medicare means testing surcharges (taken from Surcharge Savings output).";
  public healthLTCPreparedMessage: string = "This metric is the approximate total health care costs calculated throughout all client reports effective March 5, 2018.";
  public clientsAddedMessage: string = "This metric measures the total households of clients that have been added within this platform.";
  public reportsCreatedMessage: string = "This metric measures the total reports which have been created within this platform that have not been archived.";

  // public recentClients: any;

  public selectedClient: any;

  

  constructor(private globalService: GlobalService, private snackBarService: SnackBarService, private modalService: ModalService, private loadingService: LoadingService) {
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') {
        this.recentClients = [];
        this.getClients();
      }
    });
  }

  getMetrics() {
    this.globalService.getMetrics()
    .subscribe(
    resp => {
      // console.log(resp);

      var ssReportsByClient = [];
      var hcReportsByClient = [];
      var mmtReportsByClient = [];

      for (var report in resp.hcReports) {
        if (!hcReportsByClient[resp.hcReports[report].r.ClientID]) {
          hcReportsByClient[resp.hcReports[report].r.ClientID] = [];
          hcReportsByClient[resp.hcReports[report].r.ClientID].push(resp.hcReports[report]);
        } else {
          hcReportsByClient[resp.hcReports[report].r.ClientID].push(resp.hcReports[report]);
        }
      }

      var hcReportMetric = 0;

      for (var client in hcReportsByClient) {
        if (hcReportsByClient[client][hcReportsByClient[client].length - 1].hc.FundCosts) {
          hcReportMetric = hcReportMetric + hcReportsByClient[client][hcReportsByClient[client].length - 1].hc.FundCosts;
        }
      }

      for (var report in resp.mmtReports) {
        if (!mmtReportsByClient[resp.mmtReports[report].r.ClientID]) {
          mmtReportsByClient[resp.mmtReports[report].r.ClientID] = [];
          mmtReportsByClient[resp.mmtReports[report].r.ClientID].push(resp.mmtReports[report]);
        } else {
          mmtReportsByClient[resp.mmtReports[report].r.ClientID].push(resp.mmtReports[report]);
        }
      }

      var mmtReportMetric = 0;

      for (var client in mmtReportsByClient) {
        if (mmtReportsByClient[client][mmtReportsByClient[client].length - 1].mmt.SurchargeSavings) {
          mmtReportMetric = mmtReportMetric + mmtReportsByClient[client][mmtReportsByClient[client].length - 1].mmt.SurchargeSavings;
        }
      }

      for (var report in resp.ssReports) {
        if (!ssReportsByClient[resp.ssReports[report].r.ClientID]) {
          ssReportsByClient[resp.ssReports[report].r.ClientID] = [];
          ssReportsByClient[resp.ssReports[report].r.ClientID].push(resp.ssReports[report]);
        } else {
          ssReportsByClient[resp.ssReports[report].r.ClientID].push(resp.ssReports[report]);
        }
      }

      var ssReportMetric = 0;

      for (var client in ssReportsByClient) {
        // console.log(ssReportsByClient[client][ssReportsByClient[client].length - 1]);

        if (ssReportsByClient[client][ssReportsByClient[client].length - 1].ss.AddedSocialBenefit) {
          // console.log(ssReportsByClient[client][ssReportsByClient[client].length - 1].ss.AddedSocialBenefit);
          ssReportMetric = ssReportMetric + ssReportsByClient[client][ssReportsByClient[client].length - 1].ss.AddedSocialBenefit;
        }
      }

      // console.log(ssReportMetric);

      var chcc = this.roundAndFormat(hcReportMetric, 0);
      var dt = this.roundAndFormat(ssReportMetric + mmtReportMetric, 0);

      this.cumulativeHCC = chcc; //.shortValue ? chcc.shortValue + chcc.suffix : 0
      this.disposableTotal = dt; //.shortValue ? dt.shortValue + dt.suffix : 0

      // this.animateValue(this.totalPremiumsEl, 0, this.roundAndFormat(tp, 0));
      // this.animateValue(this.totalPremiumsEl, 0, this.roundAndFormat(tp, 0));


    },
    error => this.error = <any>error);
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed),
        d = c < 0 ? c : Math.abs(c),
        e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  public disposableTotal: any;
  public cumulativeHCC: any;

  ngOnInit() {
    if(localStorage.getItem('featHomeOffice') != 'undefined'){
      this.globalService.featHomeOffice = JSON.parse(localStorage.getItem('featHomeOffice'));
    }
    this.loadingService.isLoading(true);
    this.getClients();
    this.getReports();
    this.getMetrics();
  }

  getClients() {
    
    this.globalService.getClientsData()
      .subscribe(
      clients => {
        this.clientsAdded = Utils.formatNumber(clients.length);
        this.totalClients = clients.length;
        this.allClients = clients.map((item) => {
          if (item.c) {
            return {
              name: item.c.FirstName + " " + item.c.LastName,
              email: item.c.Email,
              phone: item.c.Phone || '--',
            }
          } else {
            return {
              name: item.FirstName + " " + item.LastName,
              email: item.Email,
              phone: item.Phone || '--',
            }
          }
          
        });

        this.allClients = this.allClients.reverse();
        
        for (var i = 0; i < 5; i++) {
          if (this.allClients[i]) {
            this.recentClients.push(this.allClients[i]);
          } else {
            this.recentClients.push({
              name: '--',
              email: '--',
              phone: '--',
            });
          }
        }
      },
      error => {
        this.error = <any>error
        
      });
  }

  getReports() {
    this.globalService.getReportsData()
        .subscribe(
            reports => {
              var allReports = [];

              for (var type in reports) {
                reports[type].forEach((report) => {
                  allReports.push(report);
                });
              }

              // console.log(allReports);

              this.reportsCreated = Utils.formatNumber(allReports.length);

              this.allReports = allReports.map((item) => {
                return {
                  firstName: item.c.FirstName ,
                  lastName: item.c.LastName,
                  clientName: item.c.FirstName + " " + item.c.LastName,
                  reportType: Utils.formatReportTypeID(item.r.ReportTypeID),
                  reportTypeID: item.r.ReportTypeID,
                  date: item.r.Created_Date,
                  reportID: item.r.ReportID,
                  clientID: item.c.ID,
                  advisorID: item.r.AdvisorID,
                  companyCode: item.r.CompanyCode,
                }
              });


              this.allReports = this.allReports.sort((d1, d2) => {
                return Number(new Date(d2.date)) - Number(new Date(d1.date));
              });

              for (var i = 0; i < 5; i++) {
                if (this.allReports[i]) {
                  this.recentReports.push(this.allReports[i]);
                } else {
                  this.recentReports.push({
                    clientName: '--',
                    reportType: '--',
                    date: '--',
                  });
                }
              }
              this.loadingService.isLoading(false);
            },
            error => {
              this.error = <any>error;
              this.loadingService.isLoading(false);
            });
  }

  downloadReport(e, report) {
    
    var reportID = report.reportID;
    var advisorID = report.advisorID;
    var clientID = report.clientID;
    var orgID = report.companyCode;
    var reportTypeID = report.reportTypeID;

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer") };
    this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID)} report`, 0);
    
    this.loadingService.isLoading(true);

    this.globalService.generateReport(ReportFields, report, ReportFields)
      .subscribe(
      resp => {
        // console.log('downloading report');
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error
        this.loadingService.isLoading(false);
      });
  }

  // formatReportTypeID(ReportTypeID: number) {
  //   return ReportTypeID == 1 ? 'Social Security' : ReportTypeID == 2 ? 'Medicare Means Testing' : 'Healthcare'
  // }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  }

  handleCreateClientModal(e) {
    this.modalService.add('add-edit-client', { ID: 0 });
  }

  handleCreateAdvisorModal(e) {
    this.modalService.add('create-advisor', { ID: 0 });
  }
}
